import React, { useContext, useEffect, useState } from 'react';
import Toast from '../../../components/toast/Toast';
import '../createSurvey.css';
import Navbar from '../../../components/navbar/Navbar';
import Steps from '../../../components/steps';
import { Button } from '@mui/material';
import Battery from '../../../components/views/Battery';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../../components/navbar/Footer';
import { StepsContext } from '../../../context/stepsContext';
import Pickles from '../../../components/particles/Pickles';
import { allFeelings } from '../../../feeling.js';
import parse from 'html-react-parser';
import {
  REACT_APP_SURVEY_ID,
  REACT_APP_SURVEY_ID_ER,
} from '../../../config.js';
export default function StepTwoTwo({ minutesDisplay, secondsDisplay }) {
  console.log(allFeelings);
  const [pickle, setPickle] = useState(false);
  const { state: stepTwoDatas } = useLocation();
  const { state } = stepTwoDatas;
  const { stepone } = stepTwoDatas;
  const { survey_id } = stepTwoDatas;
  const { personType } = stepTwoDatas;
  const { keyAreaTopTexts } = stepTwoDatas;
  const { selectedConstructsTop } = stepTwoDatas;
  const { selectedConstructsBottom } = stepTwoDatas;
  const { selected } = stepTwoDatas;
  const navigate = useNavigate();
  const [clicked, setClicked] = useState(false);

  const [feelingBattery, setFeelingsBattery] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let services = state && state.abilities;
  let affecting = state && state.costitems;
  console.log('sssss', survey_id);
  const message2 =
    state?.score > 60
      ? `You have scored <b>high</b> on the ${
          REACT_APP_SURVEY_ID_ER === survey_id ? 'workplace' : 'wellbeing'
        } experience however we would like to know how your wellbeing is affecting you and your work. Remember this is an anonymous survey so don't hold back.`
      : `We would like to know how your ${
          REACT_APP_SURVEY_ID_ER === survey_id
            ? 'work is affecting you.'
            : 'wellbeing is affecting you and your work.'
        }  Remember this is an anonymous survey so don't hold back.`;

  const [toastState, setToastState] = React.useState({
    open: false,
  });
  const handleCloseToast = () => {
    setToastState({
      open: !toastState.open,
    });
  };
  const [selectedAbilities, setselectedAbilities] = useState([]);
  const handleClick = (services) => {
    selectedAbilities.length === 3 && !selectedAbilities.includes(services)
      ? handleCloseToast()
      : setselectedAbilities(
          selectedAbilities.includes(services)
            ? selectedAbilities?.filter((n) => n !== services)
            : () => [...selectedAbilities, services]
        );
  };
  const [selectedCostitems, setselectedCostitems] = useState([]);
  const handleClickAffect = (services) => {
    selectedCostitems.length === 3 && !selectedCostitems.includes(services)
      ? handleCloseToast()
      : setselectedCostitems(
          selectedCostitems.includes(services)
            ? selectedCostitems?.filter((n) => n !== services)
            : () => [...selectedCostitems, services]
        );
  };

  const { dispatch, start } = useContext(StepsContext);
  useEffect(() => {
    // if (!start) navigate('/pageNotfound');
  }, [start, navigate]);
  const Altered =
    selectedCostitems?.length > 0 &&
    selectedAbilities?.length > 0 &&
    feelingBattery?.length > 0;
  const handleClickNav = () => {
    setPickle(true);
    setTimeout(() => {
      setPickle(false);
      dispatch({ type: 'STEP' });
      navigate('/stepthree', {
        state: {
          state: state,
          feeling: feelingBattery,
          selectedAbilities: selectedAbilities,
          stepone: stepone,
          keyAreaTopTexts: keyAreaTopTexts,
          selectedConstructsTop: selectedConstructsTop,
          selectedConstructsBottom: selectedConstructsBottom,
          selectedCostitems: selectedCostitems,
          selected: selected,
          survey_id: survey_id,
          personType: personType,
        },
      });
    }, 1000);
  };
  console.log(selectedAbilities?.includes('i feel great'));
  console.log(selectedAbilities);
  return (
    <div className="mainContainer">
      <Navbar
        special={
          REACT_APP_SURVEY_ID === survey_id ||
          REACT_APP_SURVEY_ID_ER === survey_id
        }
        minutesDisplay={minutesDisplay}
        secondsDisplay={secondsDisplay}
      />

      {pickle && <Pickles />}
      <div className="surveys-sub-container">
        <Steps er={REACT_APP_SURVEY_ID_ER === survey_id} step={22} active />
        <div className="inst-sub">
          <div className="link-sub">{parse(message2)}</div>
        </div>
        <div className="surveys-question-container surveys-question-container-two survey-slider-container">
          <div className="surveyServices">
            <div>
              <div className="ssTitle">
                {REACT_APP_SURVEY_ID_ER === survey_id
                  ? 'How is your experience affecting you?'
                  : 'How is your wellbeing affecting you?'}
              </div>
              <div className="link-sub-red">* Choose up to 3 aspects</div>
            </div>

            {state?.score > 65 && (
              <div
                style={{
                  border: '5px solid #2497a6',
                  backgroundColor: selectedAbilities.includes('I feel great')
                    ? '#2497a6'
                    : 'transparent',
                  color: selectedAbilities.includes('I feel great')
                    ? '#fff'
                    : '#000',
                }}
                onClick={() => handleClick('I feel great')}
                // onClick={() => handleClick('I feel great')}
                className="sslistitem  xs:!text-sm"
              >
                I feel great
              </div>
            )}
            <div className="ssItem">
              {services?.map((service, _) => (
                <div
                  style={{
                    border: '5px solid #2497a6',
                    backgroundColor: selectedAbilities.includes(service)
                      ? '#2497a6'
                      : 'transparent',
                    color: selectedAbilities.includes(service)
                      ? '#fff'
                      : '#000',
                    display: service === 'I feel great' ? 'none' : 'flex',
                  }}
                  key={_}
                  onClick={() => handleClick(service)}
                  className="sslistitem  xs:!text-sm"
                >
                  {service}
                </div>
              ))}
            </div>
          </div>
          <div className="surveyServices">
            <div>
              <div className="ssTitle">
                {REACT_APP_SURVEY_ID_ER === survey_id
                  ? 'How is your experience affecting performance?'
                  : 'How is your wellbeing affecting your work?'}
              </div>
              <div className="link-sub-red">* Choose up to 3 areas</div>
            </div>
            {state?.score > 60 && (
              <div
                style={{
                  border: '5px solid #2497a6',
                  backgroundColor: selectedCostitems.includes('I feel great')
                    ? '#2497a6'
                    : 'transparent',
                  color: selectedCostitems.includes('I feel great')
                    ? '#fff'
                    : '#000',
                }}
                onClick={() => handleClickAffect('I feel great')}
                className="sslistitem  xs:!text-sm"
              >
                I feel great
              </div>
            )}
            <div className="ssItem">
              {affecting?.map((service, _) => (
                <div
                  style={{
                    border: '5px solid #2497a6',
                    backgroundColor: selectedCostitems.includes(service)
                      ? '#2497a6'
                      : 'transparent',
                    color: selectedCostitems.includes(service)
                      ? '#fff'
                      : '#000',
                    display: service === 'I feel great' ? 'none' : 'flex',
                  }}
                  key={_}
                  onClick={() => handleClickAffect(service)}
                  className="sslistitem xs:!text-sm"
                >
                  {service}
                </div>
              ))}
            </div>
          </div>
          <div className="surveyServices">
            <div className="ssTitle">Overall how do you feel about work?</div>

            <Battery
              clicked={clicked}
              setClicked={setClicked}
              allFeelings={allFeelings}
              feeling={feelingBattery}
              setFeelings={setFeelingsBattery}
            />
          </div>
          <Toast
            handleClose={handleCloseToast}
            state={toastState}
            error="Sorry, You cannot choose more than 3."
          />
        </div>
        <div className="btn-container">
          {/* <Link to={'/stepthree'}> */}
          <Button
            disabled={!Altered}
            onClick={handleClickNav}
            className="signupCVbtnSign"
            type="submit"
            variant="contained"
            style={{
              backgroundColor: !Altered ? '' : '#2691a3',
            }}
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              padding: '8px 30px',
              textTransform: 'capitalize',
              backgroundColor: '#2691a3',
              '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                backgroundColor: '#2691a3',
              },
            }}
          >
            Next
          </Button>
          {/* </Link> */}
        </div>

        <Footer />
      </div>
    </div>
  );
}
